export default {
    // Track the time to get TxP data for an item
    RPPerfGetTailoredXpData: {
        datapoint: { name: 'RPPerfGetTailoredXpData' },
    },
};
//# sourceMappingURL=datapoints.js.map